import { IconChevronDown, IconChevronUp } from "@tabler/icons-react";
import T from "prop-types";

const propTypes = {
  isOpen: T.bool,
  title: T.string.isRequired,
};

function HeaderInfoAccordion({ isOpen = false, title }) {
  return (
    <div
      className={`flex flex-row items-center justify-between bg-primary-25 h-14 p-4 cursor-pointer
        ${isOpen ? `rounded-t-md` : `rounded-md`}
      `}
    >
      <div className="text-base text-grey-900 first-letter:capitalize">
        {title}
      </div>
      {isOpen ? (
        <IconChevronUp className="w-6 h-6 text-primary-700" />
      ) : (
        <IconChevronDown className="w-6 h-6 text-primary-700" />
      )}
    </div>
  );
}

HeaderInfoAccordion.propTypes = propTypes;
export default HeaderInfoAccordion;
